import script from "./sw-item-editor-sign.vue?vue&type=script&setup=true&lang=js"
export * from "./sw-item-editor-sign.vue?vue&type=script&setup=true&lang=js"

import "./sw-item-editor-sign.vue?vue&type=style&index=0&id=b8cf1de6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8cf1de6"]])

export default __exports__